import React, { useCallback } from 'react';
import { Column, LoadingDots, LoadingSpinner, Row } from '@mattilsynet/mt-ui';
import { useAndreDeltakere } from '../index';
import { useDeltakereFns, useRemoveEmptyDeltaker } from '../hooks/component-hooks';
import { DeleteModal } from '../../../modals';
import AddDeltaker from './add-deltaker';
import { DeltakerItem } from './deltaker-item';
import { DeltakerTypes } from '../types';
import { useKvitteringId } from '../../../common/kvittering-context';
export const AndreDeltakere = () => {
  const kvitteringId = useKvitteringId();
  const deltakere = useAndreDeltakere(kvitteringId);
  const {
    onAdd,
    onUpdate,
    onRemove,
    shouldAutoFocus,
    remove,
    setDeltakerToBeRemoved,
    hasError,
    deltakerToBeRemoved,
    isAddLoading
  } = useDeltakereFns(deltakere, kvitteringId, DeltakerTypes.ANDRE);
  useRemoveEmptyDeltaker(deltakere.data ?? [], onRemove);
  const onCancelRemove = useCallback(() => setDeltakerToBeRemoved(undefined), [setDeltakerToBeRemoved]);
  return <>
      <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="andre-deltakere.tsx">
        <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="andre-deltakere.tsx">
          <Row className="info-header" data-sentry-element="Row" data-sentry-source-file="andre-deltakere.tsx">Andre til stede</Row>

          {deltakere.isLoading && <Row center>
              <LoadingSpinner title={'Laster deltakerer...'} small />
            </Row>}

          {!deltakere.isLoading && deltakere.data?.map(deltaker => <DeltakerItem key={deltaker.id} deltaker={deltaker} onUpdateDeltaker={onUpdate} onRemoveDeltaker={onRemove} autoFocus={shouldAutoFocus(deltaker)} danger={hasError} />)}
        </Column>

        {(isAddLoading || deltakere.isFetching && deltakere.data?.length === 0) && <Row justify="center">
            <LoadingDots />
          </Row>}

        {!deltakere.isLoading && <AddDeltaker onAdd={onAdd} />}
      </Column>

      <DeleteModal isOpen={!!deltakerToBeRemoved} onCancel={onCancelRemove} onDelete={remove} title="Er du sikker på at du vil slette deltaker?" confirmText="Ja, jeg vil slette deltaker" cancelText="Avbryt" data-sentry-element="DeleteModal" data-sentry-source-file="andre-deltakere.tsx" />
    </>;
};